import { useNavigate, Link } from "react-router-dom";
import useLogout from "../hooks/useLogout";
import useAuth from "../hooks/useAuth";
import useNasaApod from "../hooks/useNasaApod";
import ApodMedia from "./ApodMedia";
import 'bootstrap-icons/font/bootstrap-icons.css';

const ROLES = { Editor: 1984, Admin: 5150, DungeonMaster: 2020 };

const Home = () => {
  const logoutFn = useLogout();
  const navigate = useNavigate();
  const { auth } = useAuth();
  const { apod, loading: apodLoading, error: apodError } = useNasaApod();
  const canEditor = auth?.roles?.some((role) =>
    [ROLES.Editor, ROLES.Admin, ROLES.DungeonMaster].includes(role)
  );
  const canAdmin = auth?.roles?.some((role) =>
    [ROLES.Admin, ROLES.DungeonMaster].includes(role)
  );

  const loungeLinks = [
    { to: '/recipes', label: 'Recipe Book', icon: 'bi-journal-bookmark' },
    { to: '/shopping-list', label: 'Shopping List', icon: 'bi-basket' },
    { to: '/map?view=restaurants', label: 'Restaurants Map', icon: 'bi-shop' },
    { to: '/map?view=grocery', label: 'Grocery Map', icon: 'bi-cart3' },
    { to: '/billing', label: 'Plans', icon: 'bi-credit-card' },
  ];
  if (canEditor) loungeLinks.push({ to: '/editor', label: 'Editor', icon: 'bi-pencil-square' });
  if (canAdmin) loungeLinks.push({ to: '/admin', label: 'Admin', icon: 'bi-gear' });

  const logout = async () => {
    await logoutFn();
    navigate('/login');
  };

  const apodLabel = apod?.isVideo ? 'Video' : 'Picture';

  return (
    <div className="lounge-page">
      <div className="lounge-grid">
        <section className="lounge-card lounge-main-card">
          <h1 className="lounge-title">Lounge</h1>
          <p className="lounge-welcome">
            Welcome to Recipe Lab! Browse the community recipe book, save a copy of anything you like,
            build a shopping list, explore lunch spots, and compare grocery prices. Pull up a chair and explore.
          </p>

          <nav className="lounge-nav">
            {loungeLinks.map((link) => (
              <Link key={link.to} to={link.to} className="lounge-nav-link">
                <i className={`bi ${link.icon}`} />
                {link.label}
              </Link>
            ))}
          </nav>

          <button type="button" className="recipe-btn recipe-btn-ghost lounge-signout" onClick={logout}>
            <i className="bi bi-box-arrow-right" /> Sign Out
          </button>
        </section>

        <section className="lounge-card lounge-apod-card">
          <h2 className="lounge-apod-heading">
            <i className="bi bi-stars" /> NASA {apodLabel} of the Day
            {apod && (
              <span className={`lounge-apod-type ${apod.isVideo ? 'video' : 'image'}`}>
                {apod.isVideo ? 'Video' : 'Image'}
              </span>
            )}
          </h2>

          {apodLoading && (
            <div className="lounge-apod-loading">
              <i className="bi bi-hourglass-split" />
              <span>Loading today's feature...</span>
            </div>
          )}

          {!apodLoading && apodError && (
            <p className="lounge-apod-error">{apodError} The lounge is still open!</p>
          )}

          {!apodLoading && !apodError && apod ? (
            <div className="lounge-apod-content">
              <h3 className="lounge-apod-title">{apod.title}</h3>
              <ApodMedia
                url={apod.url}
                embedUrl={apod.embedUrl}
                mediaType={apod.mediaType}
                title={apod.title}
              />
              <p className="lounge-apod-text">{apod.explanation}</p>
            </div>
          ) : !apodLoading && !apodError && (
            <div className="lounge-apod-loading">
              <i className="bi bi-hourglass-split" />
              <span>Loading today's feature...</span>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default Home;